import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const FormaPagoSri = {

   // async Get(qs) { return await methods.Get("AtencionAlumno/GetById" + useParamsJson(qs)) },
    async Get() { return await methods.Get("FormaPagoSri/Get" ) },
    async Post(data) { return await methods.Post("FormaPagoSri/Post", data) },
    async Put(qs, data) { return await methods.Put("FormaPagoSri/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("FormaPagoSri/Delete" + useParamsJson(qs)) }
};

export default FormaPagoSri;